import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { Box, Text, getPaletteColor } from 'pcln-design-system'
import { NotificationImage } from '@pcln/notification'
import styled from 'styled-components'
import guestsImage from '../../../../public/assets/images/guests.png'
import { numberOfViewersQuery } from '../../actions/flexDates/helpers/requestHandlers'
import { logSearchError } from '../../util/clientLogger'
import { fireGtm } from '../../util/flyGaLogic'
import { airPriceGuideNumViewers } from '../FlexDatesTiles/apolloClientQueries'

const StyledBox = styled(Box)`
  display: none;
  ${props => props.theme.flyQueries.tablet} {
    display: block;
  }
`

const ViewersFlyIn = ({
  returningFrom,
  travelDate,
  defaultFilterAirports,
  isIE,
}) => {
  // Display the component if the flexDates API results has more than 40 viewers
  const MIN_NUM_OF_VIEWERS = 40
  const [showBanner, setShowBanner] = useState(true)
  const { cityCode, airportCode } = returningFrom
  let destinationName = returningFrom.cityName

  const isDefaultAirports =
    !!defaultFilterAirports && defaultFilterAirports.length > 0
  if (cityCode !== airportCode && isDefaultAirports) {
    destinationName = get(
      defaultFilterAirports,
      '[0].destinationAirports[0].primaryLabel',
      ''
    )
  }

  let apolloNumViewers

  const numViewersQuery = numberOfViewersQuery({
    cityCode,
    airportCode,
    travelDate,
  })

  if (numViewersQuery?.showOnly) {
    delete numViewersQuery.showOnly
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, error } = useQuery(airPriceGuideNumViewers, {
    variables: { input: numViewersQuery },
  })
  if (error) {
    setShowBanner(false)
    const errorObject = {
      action: 'Apollo Client Flex Dates viewers',
      errorMessage: JSON.stringify(error),
    }
    logSearchError(errorObject)
  }
  if (data?.airPriceGuide?.viewers) {
    apolloNumViewers = data?.airPriceGuide?.viewers
  }

  const dismissBanner = () => {
    setShowBanner(false)
    fireGtm('send', 'event', 'MFLY-Listings', 'Currently viewing clicked X')
  }

  const headerContent = () => {
    return (
      <Text mr={3} bold color='text.base'>
        Book before prices go up!
      </Text>
    )
  }

  const bodyContent = () => {
    return (
      <Text regular>
        <Text.span bold>{Number(apolloNumViewers).toLocaleString()} </Text.span>
        people are searching for flights to {destinationName}.
      </Text>
    )
  }
  if (
    showBanner &&
    apolloNumViewers >= MIN_NUM_OF_VIEWERS &&
    isDefaultAirports &&
    !isIE
  ) {
    return (
      <StyledBox>
        <NotificationImage
          data-test='flex-dates-flyin-viewers'
          renderHeaderContent={headerContent}
          renderDynamicContent={bodyContent}
          handleCloseClick={dismissBanner}
          animationDelay={'16'}
          imageUrl={guestsImage}
          leftBarColor={getPaletteColor('alert.base')}
          bottom={true}
        />
      </StyledBox>
    )
  }

  return null
}

ViewersFlyIn.propTypes = {
  returningFrom: PropTypes.object,
  travelDate: PropTypes.string,
  defaultFilterAirports: PropTypes.array,
  isIE: PropTypes.bool,
}

export { ViewersFlyIn }
